import React from 'react';
import { motion } from 'framer-motion';
import { twMerge } from 'tailwind-merge';
import { spring } from '../../utils/motion';
interface ChipProps {
  selected?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
  icon?: React.ReactNode;
  className?: string;
}
export function Chip({
  selected,
  onClick,
  children,
  icon,
  className
}: ChipProps) {
  return <motion.button type="button" aria-pressed={selected} onClick={onClick} whileTap={{
    scale: 0.94
  }} transition={spring.snappy} className={twMerge('inline-flex h-9 items-center gap-1.5 whitespace-nowrap rounded-sm border px-3.5 text-sm font-semibold transition-[background-color,border-color,color] duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand', selected ? 'border-ink bg-ink text-bg' : 'border-line bg-surface text-ink-2 hover:border-ink-3 hover:text-ink', className)} data-id="element-771" data-mp="68o1no2c2ieq">
      {icon}
      {children}
    </motion.button>;
}